module.exports = "<span class=\"form-label__info-button-anchor js-anchor\"></span>";


//////////////////
// WEBPACK FOOTER
// ../src/form/fields/templates/infoButton.hbs
// module id = 699
// module chunks = 0